import * as moment from 'moment';

export class PenaltyStatistic {
    id: number;
    playerId: number;
    total: number;
    noGoals: number;
    goals: number;
    quote: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/penalty-statistic.model.ts